import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Global router-level scroll reset. On every pathname change the new page
// opens from the top. If the URL carries a hash (e.g. /help-center#premium)
// we scroll to that section instead.
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // wait a tick for the target section to mount
      const id = hash.replace('#', '');
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        else window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      }, 60);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
